// Comprehensive list of Saudi Arabian cities (bilingual), grouped implicitly by
// region. Used to populate the explore location filter alongside the cities that
// actually have properties in the dashboard.
export interface City {
  ar: string;
  en: string;
}

export const SAUDI_CITIES: City[] = [
  // Riyadh region
  { ar: "الرياض", en: "Riyadh" },
  { ar: "الدرعية", en: "Diriyah" },
  { ar: "الخرج", en: "Al Kharj" },
  { ar: "الدوادمي", en: "Dawadmi" },
  { ar: "المجمعة", en: "Al Majma'ah" },
  { ar: "الزلفي", en: "Al Zulfi" },
  { ar: "وادي الدواسر", en: "Wadi ad-Dawasir" },
  { ar: "الأفلاج", en: "Al Aflaj" },
  { ar: "حوطة بني تميم", en: "Hawtat Bani Tamim" },
  { ar: "شقراء", en: "Shaqra" },
  { ar: "الغاط", en: "Al Ghat" },
  { ar: "المزاحمية", en: "Al Muzahimiyah" },
  { ar: "ثادق", en: "Thadiq" },
  { ar: "حريملاء", en: "Huraymila" },
  { ar: "رماح", en: "Rumah" },
  { ar: "الحريق", en: "Al Hariq" },

  // Makkah region
  { ar: "مكة المكرمة", en: "Mecca" },
  { ar: "جدة", en: "Jeddah" },
  { ar: "الطائف", en: "Taif" },
  { ar: "القنفذة", en: "Al Qunfudhah" },
  { ar: "رابغ", en: "Rabigh" },
  { ar: "الليث", en: "Al Lith" },
  { ar: "خليص", en: "Khulais" },
  { ar: "الجموم", en: "Al Jumum" },
  { ar: "تربة", en: "Turabah" },
  { ar: "رنية", en: "Ranyah" },

  // Madinah region
  { ar: "المدينة المنورة", en: "Medina" },
  { ar: "ينبع", en: "Yanbu" },
  { ar: "العلا", en: "AlUla" },
  { ar: "بدر", en: "Badr" },
  { ar: "خيبر", en: "Khaybar" },
  { ar: "المهد", en: "Mahd adh Dhahab" },

  // Eastern Province
  { ar: "الدمام", en: "Dammam" },
  { ar: "الخبر", en: "Khobar" },
  { ar: "الظهران", en: "Dhahran" },
  { ar: "الأحساء", en: "Al Ahsa" },
  { ar: "الهفوف", en: "Hofuf" },
  { ar: "المبرز", en: "Al Mubarraz" },
  { ar: "القطيف", en: "Qatif" },
  { ar: "الجبيل", en: "Jubail" },
  { ar: "حفر الباطن", en: "Hafar Al-Batin" },
  { ar: "رأس تنورة", en: "Ras Tanura" },
  { ar: "بقيق", en: "Buqayq" },
  { ar: "النعيرية", en: "An Nu'ayriyah" },
  { ar: "قرية العليا", en: "Qaryat al-Ulya" },

  // Qassim region
  { ar: "بريدة", en: "Buraidah" },
  { ar: "عنيزة", en: "Unaizah" },
  { ar: "الرس", en: "Ar Rass" },
  { ar: "المذنب", en: "Al Midhnab" },
  { ar: "البكيرية", en: "Al Bukayriyah" },
  { ar: "البدائع", en: "Al Bada'i" },
  { ar: "رياض الخبراء", en: "Riyadh Al Khabra" },

  // Asir region
  { ar: "أبها", en: "Abha" },
  { ar: "خميس مشيط", en: "Khamis Mushait" },
  { ar: "بيشة", en: "Bisha" },
  { ar: "النماص", en: "An Namas" },
  { ar: "محايل عسير", en: "Muhayil" },
  { ar: "ظهران الجنوب", en: "Dhahran Al Janub" },
  { ar: "سراة عبيدة", en: "Sarat Abidah" },
  { ar: "أحد رفيدة", en: "Ahad Rafidah" },
  { ar: "تثليث", en: "Tathlith" },

  // Tabuk region
  { ar: "تبوك", en: "Tabuk" },
  { ar: "ضباء", en: "Duba" },
  { ar: "الوجه", en: "Al Wajh" },
  { ar: "أملج", en: "Umluj" },
  { ar: "حقل", en: "Haql" },
  { ar: "تيماء", en: "Tayma" },
  { ar: "نيوم", en: "NEOM" },

  // Hail region
  { ar: "حائل", en: "Hail" },
  { ar: "بقعاء", en: "Baqaa" },
  { ar: "الشنان", en: "Ash Shinan" },

  // Northern Borders
  { ar: "عرعر", en: "Arar" },
  { ar: "رفحاء", en: "Rafha" },
  { ar: "طريف", en: "Turaif" },

  // Jazan region
  { ar: "جازان", en: "Jazan" },
  { ar: "صبيا", en: "Sabya" },
  { ar: "أبو عريش", en: "Abu Arish" },
  { ar: "صامطة", en: "Samtah" },
  { ar: "فرسان", en: "Farasan" },
  { ar: "الدرب", en: "Ad Darb" },
  { ar: "بيش", en: "Baish" },

  // Najran region
  { ar: "نجران", en: "Najran" },
  { ar: "شرورة", en: "Sharurah" },
  { ar: "حبونا", en: "Habuna" },

  // Al Bahah region
  { ar: "الباحة", en: "Al Bahah" },
  { ar: "بلجرشي", en: "Baljurashi" },
  { ar: "المندق", en: "Al Mandaq" },
  { ar: "المخواة", en: "Al Makhwah" },
  { ar: "العقيق", en: "Al Aqiq" },

  // Al Jouf region
  { ar: "سكاكا", en: "Sakaka" },
  { ar: "القريات", en: "Al Qurayyat" },
  { ar: "دومة الجندل", en: "Dumat al-Jandal" },
];
